import React from "react";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {Chip} from "@mui/material";
import {EllipsisCutoff} from "../ellipsis-cutoff/EllipsisCutoff";
import {environment} from "../../env";
import {useStores} from "../../stores";

export const CategoryChip: React.FC<{labels: string[]}> = ({labels}) => {
    const {p} = useStores();

    return <>
        {labels.map((c, i) => {
            const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
            return <React.Fragment key={i}>
                <Chip
                    // variant={reviewPageFilterController.selectedCategory === c ? "default" : "outlined"}
                    variant="outlined"
                    // color={reviewPageFilterController.selectedCategory === c ? "primary" : "default"}
                    size="small"
                    label={<EllipsisCutoff
                        txt={categoryLabel}
                        max={p.p.categoryNameCutoffEllipsisChars ?? environment.categoryNameCutoffEllipsisChars}
                    />}
                />
                {i < labels.length - 1 ? ' > ' : ''}
            </React.Fragment>
        })}
    </>
}
